import { Grid, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { useQueryParams } from 'use-query-params';

import Page from 'common/shared-ui/src/components/Page';

import { useTranslation } from '../../../../packages/common/utils/getLocalString';
import LeftContainer from '../LeftContainer';
import RightContainer from '../RightContainer';

// Original class: AuthContainerRoot
const StyledAuthContainerRoot = styled(Page)(({ theme }) => ({
  backgroundColor: '#DCDFF4',
  padding: theme.spacing(8),
  height: '100vh',

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4),
  },
}));

const AuthContainer = ({ userInfo, redmineToken }) => {
  const getLocalString = useTranslation();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('md'),
  );
  const [backUrl, setBackUrl] = useState(
    window.localStorage.getItem('back_url'),
  );
  const [query, setQuery] = useQueryParams({
    back_url: '',
    redmine_token: '',
  });

  useEffect(() => {
    if (!userInfo) {
      return;
    }

    window.location.href = localStorage.getItem('back_url')
      ? localStorage.getItem('back_url')
      : `/projects`;
  }, [userInfo, query.back_url, backUrl]);

  return (
    <StyledAuthContainerRoot title={getLocalString('AuthContainer', 'title')}>
      <Grid
        container
        wrap='nowrap'
        direction={isSmallScreen ? 'column-reverse' : 'row'}
        sx={{
          alignItems: isSmallScreen && 'center',
          height: '100%',
        }}
      >
        <LeftContainer />
        <RightContainer />
      </Grid>
    </StyledAuthContainerRoot>
  );
};

const mapStateToProps = state => {
  return {
    redmineToken: state.user.redmine_access_token,
    userInfo: state.user.info,
    isUserLoading: state.user.isLoading,
  };
};

export default connect(mapStateToProps)(AuthContainer);
